import React, { useState, useEffect, useReducer } from 'react';
import { getUserHistroyService } from '../../services/campersServices';
import { getUserDetailService } from '../../services/otherService';
import { ChargeAmountReducer, convertTimeToCurrentTimeZone, initialChargeAmountModalState, resHandle } from '../../helper';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { isOnlySpaces, trimSpace } from '../bookings/bookingHelper';
import ChargeCamperModal from '../reuse/ChargeCamper/ChargeCamperModal';
import { Modal } from 'react-bootstrap';
import PaginatedComponent from '../common/Pagination/PaginationComponent';


const limit = 10
const baseClass = `d-flex justify-content-between align-items-start align-items-lg-center flex-column flex-lg-row mb-2 m_box`



const UserHistory = props => {

    const [list, setList] = useState([]);

    const [modalState, dispatch] = useReducer(ChargeAmountReducer, initialChargeAmountModalState);
    const [chargeModal, setChargeModal] = useState(false)
    const [refundModal, setRefundModal] = useState(false)
    const [refundData, setRefundData] = useState([])
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [auditUsersMap, setAuditUsersMap] = useState({});

    const handleChargeAmountReason = (newReason) => {
        if (isOnlySpaces(newReason)) {
            handleReasonError('Please Enter a valid reason.')
        } else {
            const _reason = trimSpace(newReason)
            dispatch({ type: 'SET_REASON', payload: _reason });
            handleReasonError('')
        }
    };
    const handleReasonError = (error) => {
        dispatch({ type: 'SET_REASON_ERROR', payload: error });
    };
    const handleChargeAmountChange = (amount) => {
        dispatch({ type: 'SET_AMOUNT', payload: amount });
    }
    const handleCamperList = (list) => {
        dispatch({ type: 'SET_CAMPERLIST', payload: list });
    }
    const handleCamperChange = (camper) => {
        dispatch({ type: 'SET_CAMPER_CHANGE', payload: camper });
    }
    const handleMetaDataChange = (b_id, b_no, p_id) => {
        dispatch({ type: 'SET_META_DATA', payload: { b_id, b_no, p_id } });
    }

    const getUserHistroy = () => {
        let query = `?page=${page}&limit=${limit}&userId=${props.match.params.id}&campCode=${props.userProfile.campCode}`;

        getUserHistroyService(query).then(res => {
            let { status, data } = resHandle(res);
            if (status) {
                setList(data.result);
                setTotalCount(data.count)
            }
        })
    }


    useEffect(() => {
        if (props?.match?.params?.id) {
            getUserHistroy();
        }

    }, [props, page])

    const handleChargeCustomer = (campers, bookingNo, bookingId, programId) => {
        handleMetaDataChange(bookingId, bookingNo, programId)
        setChargeModal(true)
        const _camperList = campers.map(camper => ({ label: camper.camperName, value: camper.camperId }))
        handleCamperList(_camperList)
    }

    const handleCloseChargeModal = (type = 1) => {
        dispatch({ type: 'RESET', payload: initialChargeAmountModalState })
        setChargeModal(false)
        if (type === 1) {
            getUserHistroy()
        }
    }

    const handleCloseRefundModal = () => {
        setRefundModal(false)
        setRefundData([])
    }
    const handleOpenRefundModal = (e, refunds) => {
        e.preventDefault();
        setRefundData(refunds)
        setRefundModal(true)
    }

    const getPaymentDetailsForExperience = (paymentArr, additionalExperienceId) => {
        if (!Array.isArray(paymentArr)) return null;

        const payment = paymentArr.find(p =>
            p.metadata?.purchasedAdditionalExperienceIds?.includes(additionalExperienceId)
        );

        return payment ? { amount: payment.amount, transactionId: payment.transaction_id } : null;
    };

    const getSortedAdditionalExperienceAudits = (item) => {
        const audits = [];

        item.programs?.forEach(program => {
            program.campers?.forEach(camper => {
                if (
                    !Array.isArray(camper.additionalExperience) ||
                    !Array.isArray(camper.additionalExperienceAudit)
                ) return;

                const experienceMap = new Map(
                        camper.additionalExperience.map(exp => [
                        exp.additionalExperienceId,
                        exp
                    ])
                );

                camper.additionalExperienceAudit.forEach(audit => {
                    const experience = experienceMap.get(audit.additionalExperienceId);
                    if (!experience) return;

                    // Get payment details from paymentArr if exists
                    const paymentDetails = getPaymentDetailsForExperience(
                        item.paymentArr,
                        audit.additionalExperienceId
                    );

                    audits.push({
                        ...audit,
                        camperName: camper.camperName,
                        experienceTitle: experience.title,
                        price: paymentDetails?.amount ?? experience.price,
                        addExpPrice: experience.price ?? 0,
                        transactionId: paymentDetails?.transactionId || null,
                        programName: program.programName,
                    });
                });
            });
        });

        // Latest first
        return audits.sort(
            (a, b) => new Date(b.auditDate) - new Date(a.auditDate)
        );
    };

    useEffect(() => {
        if (!list.length) return;

        // collect unique auditUser ids
        const userIds = new Set();

        list.forEach(item => {
            const audits = getSortedAdditionalExperienceAudits(item);
            audits.forEach(audit => {
            if (audit.auditUser) {
                userIds.add(audit.auditUser);
            }
            });
        });

        // remove already fetched users
        const idsToFetch = [...userIds].filter(
            id => !auditUsersMap[id]
        );

        if (!idsToFetch.length) return;

        // fetch users
        const fetchUsers = async () => {
            const users = {};

            await Promise.all(
                idsToFetch.map(async (id) => {
                    try {
                        const { status, data } = await getUserDetailService(id);
                        if( status ){
                            users[id] = data.responseData.result;
                        }
                    } catch (e) {
                        console.error("Failed to fetch user", id);
                    }
                })
            );

            // store in map
            setAuditUsersMap(prev => ({
                ...prev,
                ...users
            }));
        };

        fetchUsers();
        }, [list]);

        const getFullName = (user) =>
            [user?.name, user?.lastName].filter(Boolean).join(" ");

    // Build a unified timeline with programs, products, and additional experiences sorted globally
    const buildUnifiedTimeline = () => {
        const timeline = [];

        list.forEach((item) => {
            const isProduct = item.productPrice || item?.purchaseType === 1;

            // Add program/product entry
            timeline.push({
                type: isProduct ? 'product' : 'program',
                date: new Date(item.created),
                item,
                isProduct,
            });

            // Add additional experience entries (only for programs)
            if (!isProduct) {
                const audits = getSortedAdditionalExperienceAudits(item);
                audits.forEach((audit, index) => {
                    timeline.push({
                        type: 'additional_experience',
                        date: new Date(audit.auditDate),
                        audit,
                        item, // parent booking item for context
                        index,
                    });
                });
            }
        });

        // Sort by date, latest first
        return timeline.sort((a, b) => b.date - a.date);
    };

    const unifiedTimeline = buildUnifiedTimeline();

    const renderProgramOrProduct = (item, isProduct) => (
        <li className="mb-4" key={`${item._id}-main`}>
            <time className="d-block text-muted mb-1">
                {moment(item.created).format("DD MMM, YYYY")}
            </time>

            <span className="histroy_type">
                {isProduct ? "Products" : "Programs"}
            </span>

            <div
                className={`timeline_inner p-3 border rounded ${!isProduct && item?.bookingStatus === 2 ? "bg-light text-danger" : "bg-light"
                    }`}
            >
                {/* Status */}
                {!isProduct && (
                    <div className="has_canceled_program_text mb-2">
                        {item?.bookingStatus === 2 && <small className="text-danger fw-bold">Canceled</small>}
                        {item?.bookingStatus === 3 && <small className="text-primary fw-bold">Refunded</small>}
                        {item?.bookingStatus === 4 && (
                            <>
                                <small className="text-danger fw-bold">Canceled</small>
                                <small className="text-dark"> & </small>
                                <small className="text-primary fw-bold">Refunded</small>
                            </>
                        )}
                    </div>
                )}

                {/* Camp Name */}
                <h4 className="camp-name mb-2 d-none d-sm-inline">
                    <span className="d-none d-sm-inline">Camp Name:</span>{" "}
                    <span className="fs-5">{item?.campName}</span>
                </h4>

                {/* Booking info */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center my-3">
                    <small className="m_box">
                        <span className="d-none d-sm-inline p-1">Booking Number:</span>{" "}
                        {item?.bookingNumber}
                    </small>
                    {
                    item?.bookingSource !==2 &&
                        <small className='fw-bold text-dark'>
                            <ins>
                                Booked By : {item?.bookedBy}
                            </ins>
                        </small>
                    }
                    <h6 className="amount  text-danger mt-2 mt-sm-0 fw-bold fs-5 fs-sm-4 fs-md-3 d-block d-none d-sm-inline">
                        Amount: {!isProduct ? (item.amount ? `$${item.amount.toFixed(2)}` : "Free") :
                            item?.productPrice ? `$${item.productPrice.toFixed(2)}` : "Free"}
                    </h6>
                    <span className="text-danger fw-bold mt-2 d-block d-sm-none">
                        Amount: {!isProduct
                            ? item.amount
                                ? `$${item.amount.toFixed(2)}`
                                : "Free"
                            : item?.productPrice
                                ? `$${item.productPrice.toFixed(2)}`
                                : "Free"}
                    </span>
                </div>

                {/* Programs */}
                <div className="mb-3">
                    <h6 className="program-label mb-2">Programs:</h6>
                    {item?.programs?.map((p) => (
                        <div key={p?._id} className="mb-4">
                            <h6 className="ps-3 ps-md-5 program-name">{p?.programName}</h6>

                            {!isProduct && (
                                <>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-sm btn-primary m-0 p-0"
                                            onClick={() =>
                                                handleChargeCustomer(
                                                    p.campers,
                                                    item.bookingNumber,
                                                    item.bookingId,
                                                    p.programId
                                                )
                                            }
                                        >
                                            <small className='p-1'>Charge camper</small>
                                        </button>
                                    </div>

                                    <div className="ps-3 ps-md-5 mt-3">
                                        <small className="me-3 text-secondary">Participants:</small>
                                        {p.campers.map((cp) => (
                                            <Link
                                                key={cp?._id}
                                                to={`/bookings/${item.bookingId}/${cp.camperId}/${p.programId}`}
                                                className="d-block text-decoration-none mb-2"
                                            >
                                                <div
                                                    className={`p-2 rounded ${baseClass} ${(cp.status === 2 || cp.status === 4) && "border border-danger"
                                                        } ${cp.status === 3 && "border border-primary"}`}
                                                >
                                                    <small className="d-block">
                                                        <span className="d-none d-sm-inline">Name:</span>{" "}
                                                        {cp.camperName}
                                                    </small>

                                                    <small className="d-block d-none d-sm-inline">
                                                        <span>Booking Date:</span>{" "}
                                                        {convertTimeToCurrentTimeZone(
                                                            item?.bookingDate,
                                                            props?.userProfile?.timezone,
                                                            "MMMM DD, YYYY : hh:mm a"
                                                        )}
                                                    </small>

                                                    {cp?.refunds?.length > 0 && (
                                                        <button
                                                            className="btn btn-outline-secondary btn-sm mt-2"
                                                            onClick={(e) => handleOpenRefundModal(e, cp.refunds)}
                                                        >
                                                            Refunds
                                                        </button>
                                                    )}
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
                </div>

                {/* Products */}
                {isProduct && (
                    <div className='time_line_programs'>
                        <h5 className='m-2'>Products: </h5>
                        <div className="d-flex flex-column flex-sm-row">
                            {item.itemName.map((p) => (
                                <small key={p} className="m_box m-2">{p}</small>
                            ))}
                        </div>                                    </div>
                )}
            </div>
        </li>
    );

    const renderAdditionalExperience = (audit, item, index) => (
        <li
            key={`${item._id}-addon-${index}-${audit.additionalExperienceId}`}
            className="mb-4"
        >
            <time className="d-block text-muted mb-1">
                {moment(audit.auditDate).format("DD MMM, YYYY")}
            </time>

            <span className="histroy_type_add_exp">
                Additional Experience
            </span>

            <div
                className="timeline_inner p-3 border rounded bg-light position-relative"
            >
                <div className="has_canceled_program_text mb-2 text-end">
                    <small
                        className={`fw-bold ${
                        audit.auditType === 1 ? "text-success" : "text-danger"
                        }`}
                    >
                        {audit.auditType === 1 ? "Added" : "Removed"}
                    </small>
                </div>

                {/* CAMP NAME */}
                <h4 className="camp-name mb-2 d-none d-sm-inline">
                    <span className="d-none d-sm-inline">Camp Name:</span>{" "}
                    <span className="fs-5">{item.campName}</span>
                </h4>

                {/* BOOKING INFO */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center my-3">
                    <small className="m_box">
                        <span className="d-none d-sm-inline p-1">Booking Number:</span>{" "}
                        {item.bookingNumber}
                    </small>

                    {auditUsersMap[audit.auditUser] && (
                        <small className="fw-bold text-dark">
                            <ins>
                                Action By : {getFullName(auditUsersMap[audit.auditUser])}
                            </ins>
                        </small>
                    )}

                    <h6 className="amount text-danger fw-bold fs-5 d-none d-sm-inline">
                        Amount: {audit.price ? `$${audit.price.toFixed(2)}` : "Free"}
                    </h6>

                    <span className="text-danger fw-bold d-block d-sm-none">
                        Amount: {audit.price ? `$${audit.price.toFixed(2)}` : "Free"}
                    </span>
                </div>

                {/* PROGRAM NAME */}
                <div className="mb-3">
                    <h6 className="program-label mb-2">Program:</h6>
                    <h6 className="ps-3 ps-md-5 program-name">
                        {audit.programName}
                    </h6>
                </div>

                {/* ADDITIONAL EXPERIENCE DETAILS */}
                <h6 className="program-label mb-2">Additional Experience:</h6>
                <div className={`m_box border rounded p-2 d-flex justify-content-between align-items-start ${
                        audit.auditType === 1 ? "border-success" : "border-danger"
                    }`}
                >
                    <div>
                        <small className="fw-bold d-block">
                            {audit.experienceTitle}
                            {audit.addExpPrice ? ` - $${audit.addExpPrice.toFixed(2)}` : ""}
                        </small>

                        <small className="text-muted d-block">
                            Camper: {audit.camperName}
                        </small>

                        <small className="text-muted d-block">
                            {moment(audit.auditDate).format("MMMM DD, YYYY : hh:mm a")}
                        </small>
                    </div>

                    {audit.transactionId && (
                        <small className="text-muted">
                            Transaction ID: {audit.transactionId}
                        </small>
                    )}
                </div>
            </div>
        </li>
    );

    return (
        <div className="mt-3 ms-3 me-3">
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4>History</h4>
            </div>

            <ul className="user_timeline list-unstyled">
                {unifiedTimeline.map((entry) => {
                    if (entry.type === 'program' || entry.type === 'product') {
                        return renderProgramOrProduct(entry.item, entry.isProduct);
                    } else if (entry.type === 'additional_experience') {
                        return renderAdditionalExperience(entry.audit, entry.item, entry.index);
                    }
                    return null;
                })}
            </ul>

            {
                list.length ?
                    <div className="d-flex justify-content-center mt-5">
                        <PaginatedComponent
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalCount}
                            pageRangeDisplayed={4}
                            onPageChange={setPage} />
                    </div> : ''

            }
            <Modal
                show={refundModal}
                onHide={handleCloseRefundModal}
                centered
            >
                <Modal.Header
                    className='d-flex justify-content-center align-items-center'
                >
                    <Modal.Title >Refund History</Modal.Title>
                    <span className="modal_close" onClick={handleCloseRefundModal}><i className="icon-cross" /></span>
                </Modal.Header>
                <Modal.Body>
                    {
                        refundData.map(item =>
                            <div className='d-flex justify-content-between align-items-start align-items-lg-center flex-column flex-lg-row mb-2 m_box'>
                                <small>Refund Amount : <b>${item.refundAmount}</b></small>
                                <small>Refund Date :{moment.utc(item?.refundDate).format('MMMM DD, YYYY : hh:mm a')}</small>
                            </div>
                        )
                    }
                </Modal.Body>
            </Modal>
            <ChargeCamperModal
                modalState={modalState}
                chargeModal={chargeModal}
                handleCloseChargeModal={handleCloseChargeModal}
                handleCamperChange={handleCamperChange}
                handleChargeAmountReason={handleChargeAmountReason}
                handleChargeAmountChange={handleChargeAmountChange}
                userId={props.match.params.id}
            />

        </div>
    )
}


const mapStateToProps = state => {
    let userProfile = state.user.userProfile;
    return {
        userProfile,
    };
}


export default connect(mapStateToProps)(UserHistory);